<template>
    <div class="layout__container text__align-center">
        <h3 class="layout__padding-20-0">Unfortunately we didn't receive the correct information</h3>
        <div class="">
            <p>Please contact our team who will be happy to review your template<br> and enable you to print
                with us.</p>
            <div class="layout__padding-20-0">
                <p>Ravensworth Client Services:</p>
                <p class="text__colour-teal">0191 917 9331</p>
                <p class="text__colour-teal">client.support@ravensworth.co.uk</p>
            </div>
        </div>

    </div>

</template>

<script>

    export default {
        name: "IncompleteEntry",
        components: {},
        data() {
            return {
            }
        },
        created() {
        },
        methods: {
        }
    };
</script>